import React, { useState, useEffect } from 'react';
import '../../src/assets/css/style.css';
import footer from "../../src/assets/img/mainfooterbg.png"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getCertificateListForCitizen, getSummaryReport } from "../CertificateService"
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import Modal from 'react-modal';
import Navbar from "./Navbar";

const AchievementList = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [showDelete, setShowDelete] = useState(false);
  const [achievementList, setAchievementList] = useState([]);
  const [integerValue, setIntegerValue] = useState(null);
  const [blockList, setBlockList] = useState();
  const [userData, setUserData] = useState(null);
  const [remark, setRemark] = useState("");
  const [globalData, setGlobalData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [rating, setRating] = useState(0);
  const [dataRating, setDataRating] = useState();
  const [certificateDataList, setCertificateDataList] = useState([]);
  const [currentDate, setCurrentDate] = useState('');

  const handleCloseDelete = () => setShowDelete(false);
  const handleRatingClick = (value) => {
    setRating(value);
  };

  const getFormattedDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getFormattedDateMinusOneDay = () => {
    const today = new Date();
    today.setDate(today.getDate() - 1);
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const jsonString = localStorage.getItem("Certificate_user");
    const data = JSON.parse(jsonString);
    setUserData(data);

    getCertificateListForCitizen(data?.mobile).then(function (result) {
      const response = result?.data;
      setCertificateDataList(response);
    });

    getSummaryReport(0, 0, 0, "01.01.2024", getFormattedDate())
      .then(function (result) {
        const response = result?.data;
        setGlobalData(response);
      });
  }, []);

  const totalApply = globalData.reduce((total, item) => total + parseInt(item.apply, 10), 0);
  const totalPending = globalData.reduce((total, item) => total + parseInt(item.inProgress, 10), 0);
  const totalDownload = globalData.reduce((total, item) => total + parseInt(item.download, 10), 0);
  const totalReject = globalData.reduce((total, item) => total + parseInt(item.reject, 10), 0);

  const onAddaAchievement = () => {
    navigate(`/add-certificate`);
  };

  return (
    <div>
      <ToastContainer />
      <div className='container-fluid'>
        <div className='dbMain businessUnit'>
          <div className='dbRight'>
            <Navbar />
            <div className='commonBase'>
              <div>
                <h3 style={{ marginTop: "-50px", marginLeft: "500px", color: "orange" }}>Citizen Corner Certificate List</h3>
              </div>
              <div
                style={{
                  border: "2px solid black",
                  padding: "2px",
                  borderRadius: "5px",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span>Total Application : <b>{totalApply}</b>,</span>&nbsp;
                <span>In Progress : <b>{totalPending}</b>,</span>&nbsp;
                <span>Ready to Download : <b>{totalDownload}</b>,</span>&nbsp;
                <span>Rejected : <b>{totalReject}</b></span>
              </div>
              <br />

              <div className='dbtableTop'>
                <div className='dbSearch'></div>
                <div className='dbtableSrchbg'>
                  <button className='btn' onClick={onAddaAchievement}>
                    <i className="fa fa-solid fa-plus"></i> Apply Certificate
                  </button>
                </div>
              </div>

              <span style={{
                animation: "blink 1s infinite",
                textDecoration: "none",
                color: "black",
              }}>
                <b>To download the certificate in PDF or Print, Page set up should be:
                  Paper Size: A4-Portrait  Margin: Default  Scale : custom-80
                  Background Graphics should be on.</b>
              </span>

              <br />
              <div>
                <table>
                  <thead>
                    <tr style={{ backgroundColor: "#4CAF50", color: "black" }}>
                      <th>Applied Certificate Type</th>
                      <th>Applicant Name</th>
                      <th>Apply Date</th>
                      <th>Valid Until Date</th>
                      <th>Status of Certificate</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {certificateDataList && certificateDataList.map((d, index) => (
                      <tr key={index}>
                        <td>
                          <ul className="list-disc pl-4">
                            {d?.CHAR_CERT !== "-" && <li>{d?.CHAR_CERT}</li>}
                            {d?.INCM_CERT !== "-" && <li>{d?.INCM_CERT}</li>}
                            {d?.RESI_CERT !== "-" && <li>{d?.RESI_CERT}</li>}
                            {d?.SPER_CERT !== "-" && <li>{d?.SPER_CERT}</li>}
                            {d?.DIST_CERT !== "-" && <li>{d?.DIST_CERT}</li>}
                            {d?.CAST_CERT !== "-" && <li>{d?.CAST_CERT}</li>}
                            {d?.UNMARRIED_CERT !== "-" && <li>{d?.UNMARRIED_CERT}</li>}
                          </ul>
                        </td>

                        <td>{d?.NAME_APPLI}</td>
                        <td>{d?.SAVE_DT}</td>
                        <td>{d?.VALID_DT}</td>
                        <td>{d?.STATUS === "Rejected" ? `${d?.STATUS} (${d?.PRADHAN_RMKS})` : d?.STATUS}</td>
                        <td>
                          <Link to="/application-details" state={{ applicationId: d?.APPLICATION_ID }}>
                            <i className="fa fa-solid fa-eye"></i>
                          </Link>
                          <br />
                          {d?.STATUS === "Ready To Download" && (
                            <>
                              <Link to="/Ecertificate-download" state={{ applicationId: d?.APPLICATION_ID }}>
                                English: <i className="fa fa-solid fa-download"></i>
                              </Link>
                              <br />
                              {d?.OTH_LANG === "B" && (
                                <Link to="/Bcertificate-download" state={{ applicationId: d?.APPLICATION_ID }}>
                                  Bengali: <i className="fa fa-solid fa-download"></i>
                                </Link>
                              )}
                              {d?.OTH_LANG === "N" && (
                                <Link to="/Bcertificate-download" state={{ applicationId: d?.APPLICATION_ID }}>
                                  Nepali: <i className="fa fa-solid fa-download"></i>
                                </Link>
                              )}
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <nav className="footer" style={{ marginTop: "-100px" }}>
        <img src={footer} style={{ marginTop: "450px" }} />
        <p className="text-center lastp" style={{ fontSize: "16px !important" }}>
          <strong>©</strong> 2024 Designed and Developed By <b>IT And Statistical Cell,</b> Panchayat & Rural
          Development Department <b>Govt. of West Bengal</b>
        </p>
        <p className="text-center lastp" style={{ fontSize: "14px !important" }}>
          Site best viewed with 1920x1080 resolution in Google Chrome 31.0.1650.63, Firefox 55.0.2, Safari 5.1.7 & IE 11.0 and above
        </p>
      </nav>
    </div>
  );
};

export default AchievementList;
